import * as React from 'react';
import { getValue, Row } from '../Row';
import * as styles from './Discount.css';

interface IDiscountProps {
  discount: number;
  days?: number;
}

export const Discount = (props: IDiscountProps) => {
  const { discount, days } = props;

  const value = getValue({ price: discount, days });

  return (
    <Row
      name="Скидка"
      value={
        <span className={styles['discount']}>−{value}</span>
      }
    />
  );
};
